export default function Testimonial() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="relative">
          <div className="absolute -top-12 -left-4 w-32 h-48 opacity-20 pointer-events-none">
            <svg viewBox="0 0 120 180" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 10 C40 40 20 80 50 100 C80 120 60 160 110 170"
                stroke="oklch(0.55 0.045 58)"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className="bg-foreground-950 rounded-3xl overflow-hidden flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative min-h-[300px] lg:min-h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=European%20woman%20in%20her%20thirties%20at%20modern%20minimalist%20desk%20smiling%20at%20laptop%20screen%2C%20warm%20natural%20daylight%20from%20window%2C%20cream%20interior%20with%20plants%2C%20genuine%20satisfied%20expression%2C%20no%20text%20no%20logos%2C%20editorial%20lifestyle%20portrait&width=800&height=1000&seq=hbs-v2-testimonial-portrait&orientation=portrait"
                alt="Marie D. - Utilisatrice Hipobuy Spreadsheet"
                className="absolute inset-0 w-full h-full object-cover"
                title="Utilisatrice Hipobuy Spreadsheet"
              />
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center p-8 md:p-12 lg:p-16">
              <span className="text-6xl md:text-8xl text-background-50/15 font-heading leading-none mb-6">
                &ldquo;
              </span>

              <blockquote className="text-background-50 text-lg md:text-xl lg:text-2xl font-sans leading-relaxed mb-8 md:mb-10">
                Le Hipobuy Spreadsheet a complètement transformé ma façon de gérer mon budget. Avant, je perdais des heures à compiler mes dépenses dans des fichiers Excel complexes. Maintenant, tout est automatisé et je peux visualiser en un coup d'œil où va mon argent chaque mois. J'ai économisé plus de 400€ le premier mois simplement en identifiant mes dépenses superflues.
              </blockquote>

              <div className="mb-6 md:mb-8">
                <p className="text-background-50 font-semibold font-sans">Marie D.</p>
                <p className="text-background-50/50 text-sm font-sans">
                  Utilisatrice Hipobuy Spreadsheet 2025
                </p>
              </div>

              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 dark:text-foreground-950 font-sans text-sm font-medium px-6 py-3 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Essayer gratuitement
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}